var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG",
    clipPath: "url(#clip0_3070_22762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9496 2.66875C11.6246 2.09062 11.2715 1.98438 10.5496 1.94375C9.83398 1.89375 8.02461 1.875 6.45898 1.875C4.89023 1.875 3.08398 1.89375 2.36523 1.94375C1.64648 1.98438 1.29336 2.09062 0.965234 2.67188C0.630859 3.24688 0.458984 4.24375 0.458984 5.99687V6V6.00313V6.00625C0.458984 7.75313 0.630859 8.75625 0.965234 9.32812C1.29336 9.90625 1.64648 10.0125 2.36523 10.0594C3.08398 10.1 4.89023 10.125 6.45898 10.125C8.02461 10.125 9.83086 10.1 10.5496 10.0594C11.2684 10.0094 11.6215 9.90625 11.9465 9.32812C12.2871 8.75313 12.459 7.75 12.459 6.00313V6C12.459 6 12.459 6 12.459 5.99687C12.459 4.24375 12.2871 3.24688 11.9496 2.66875ZM4.95898 8.25V3.75L8.70898 6L4.95898 8.25Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3070_22762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.458984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeButton);
export default __webpack_public_path__ + "static/media/youtubeButton.f42890acc9946bd210ef73a583686dee.svg";
export { ForwardRef as ReactComponent };